import Mentions from './Mentions';
export default Mentions;


//////////////////
// WEBPACK FOOTER
// ../~/_rc-mentions@0.4.0@rc-mentions/es/index.js
// module id = 1345
// module chunks = 0